import { faPaperclip, faWrench } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { Popover } from 'antd';
import "./_signigs.css";
import SigningItem from './_SigningItem';
import SigningRiderItem from './_SigningRiderItem';
import "./_SignsTable.css";
import { filter } from 'lodash';
import DynamicColumns from '../dynamicColumns/_DynamicColumns';
import { DynamicColumnsModel } from '../models/DynamicColumnsModel';

type Props = {
    signingList: any[];
    signingRiderList: any[];
    statuses?: any[];
    sortBy?: any;
    className?: string;
    config?: any;
    actions?: any;
    showOnlyRiders: boolean;
    showOnlyOpens: boolean;
    setRiderToPopup: Function;
    onUpdatePaymentsClick: Function;
    onActivateRiderClick: Function;
    setSigningSeen: Function;
    onNewOrEditTreatment: Function;
    actionBtns: boolean;
};


const SelectCollumnsPopOver = (props: any) => {


    const [optionsList, setOptionsList] = useState<any[]>([]);


    const buildOptionslist = () => {
        const collumnsNames = Object.keys(props.options);
        const rows: any[] = [];
        collumnsNames.forEach((collumn: string, key: number) => {
            rows.push({
                label: props.options[collumn].label,
                value: collumn,
                checked: !props.options[collumn].hidden
            });
        });
        setOptionsList(rows);

    }

    const onCheck = (optionValue: string) => {
        console.log('SelectCollumnsPopOver onCheck', optionValue);
        if (props.onCheck) {
            console.log('SelectCollumnsPopOver props.onCheck', props.onCheck);

            const opts = props.options;
            console.log('SelectCollumnsPopOver opts before', opts);
            opts[optionValue].hidden = !opts[optionValue].hidden
            props.onCheck(opts)
        }
    }

    const onClose = () => {
        if (props.onHide) {
            props.onHide()
        }
    }

    useEffect(() => {
        buildOptionslist();
    }, [props.options]);

    useEffect(() => {
        buildOptionslist();
    }, []);

    return (
        <div>
            {optionsList.map((option: any, index: number) => {
                return (
                    <div key={index} className='flex-start flex-reverse'>
                        <input type='checkbox'
                            onChange={() => onCheck(option.value)} />
                        <div>
                            {option.label}
                        </div>
                    </div>
                )
            })}
            <a onClick={onClose}>Close</a>

        </div>
    )
}

const SigningTable = (props: Props) => {
    var borderBold = false;
    var idNumber = 0;

    const [itemsList, setItemsList] = useState<any[]>([]);
    const [itemsRiderList, setItemsRiderList] = useState<any[]>([]);
    const [showDropDown, setShowDropDown] = useState(false);
    const [additionalColumns, setAdditionalColumns] = useState<any>({

        identifier: {
            hidden: true,
            label: 'ת.ז.',
        },
        agent: {
            hidden: true,
            label: 'סוכן',
        },
        clientsGroups: {
            hidden: true,
            label: 'קבוצת לקוחות',
        },

        shield: {
            hidden: true,
            label: 'מיגון',
        },
        claims: {
            hidden: true,
            label: 'ה. תביעות',
        },
        documents: {
            hidden: true,
            label: 'מסמכים',
        },
        sending: {
            hidden: true,
            label: 'שליחה',
        },
        productionType: {
            hidden: true,
            label: 'סוג הפקה',
        }
    });
    const [sortBy, setSortBy] = useState<any | null>(null);


    ////////////////////////////////Dynamic Columns//////////////////////////////////////
    const [dynamicColsList, setDynamicColsList] = useState<string[]>([]);
    const dynamicColumnsModel: DynamicColumnsModel = new DynamicColumnsModel();
    const buildDynamicColsList = async () => {
        await dynamicColumnsModel.DynamicColsGetUserDynamicColsNamesByModuleName("Signings").then((res: any) => {
            setDynamicColsList(res);
        });

    };

    useEffect(() => {
        const fetchData = async () => {
            await buildDynamicColsList();
        };

        fetchData();
    }, []);
    ////////////////////////////////Dynamic Columns//////////////////////////////////////


    const onSortChange = (property: string) => {
        if (props.actions.onSortChange) {
            props.actions.onSortChange(property)
        }
    }

    const onSelectSigning = (id: string) => {
        if (props.actions && props.actions.onSelectSigning) {
            props.actions.onSelectSigning(id);
        }
    }

    const onAddTask = () => {
        // onAddTask
        if (props.actions && props.actions.onAddTask) {
            props.actions.onAddTask();
        }
    }

    const onAssignToHandler = (id: string) => {
        if (props.actions && props.actions.assignToHandler) {
            props.actions.assignToHandler(id);
        }
    }

    const addSigningComment = (commentData: any, signingId: string) => {
        if (props.actions && props.actions.addSigningComment) {
            props.actions.addSigningComment(commentData, signingId);
        }
    }


    const handleOpenChange = (newOpen: boolean) => {
        setShowDropDown(newOpen);
        console.log('onMenuOptionChange hide', newOpen)
    };
    const onMenuOptionChange = (options: any) => {
        console.log('onMenuOptionChange', options)
        setAdditionalColumns(options)
    }


    const editTask = (id: string) => {
        console.log('editTask');
        if (props.actions && props.actions.edit) {
            props.actions.edit(id)
        }
    }
    const onUpdate = (data: any) => {
        console.log('onUpdate');
        if (props.actions && props.actions.update) {
            props.actions.update(data)
        }
    }
    const sendEmail = (id: string) => {
        console.log('sendEmail');
        if (props.actions && props.actions.sendEmail) {
            props.actions.sendEmail(id)
        }
    }
    const sendWhatsApp = (id: string) => {
        console.log('sendWhatsApp');
        if (props.actions && props.actions.sendWhatsApp) {
            props.actions.sendWhatsApp(id)
        }
    }
    const setStatus = (id: string, status: string) => {
        console.log('setStatus');
        if (props.actions && props.actions.setStatus) {
            props.actions.setStatus(id, status);
        }
    }
    const deleteSigning = (id: string, status: string) => {
        console.log('deleteSigning');
        if (props.actions && props.actions.delete) {
            props.actions.delete(id);
        }
    }

    const onShowDocument = (url: string) => {
        if (props.actions && props.actions.onShowDocument) {
            props.actions.onShowDocument(url);
        }
    }

    const setCheckboxRiderStateData = (e: any, index: number) => {
        if (props.actions && props.actions.setCheckboxRider) {
            props.actions.setCheckboxRider(e, index);
        }
    }

    useEffect(() => {
        const data = props.signingList ? props.signingList : [];
        setItemsList(data);
        console.log('data changed', props.signingList)
    }, [props.signingList]);

    useEffect(() => {
        const data = props.signingRiderList ? props.signingRiderList : [];
        setItemsRiderList(data);
        console.log('data changed', props.signingRiderList)
    }, [props.signingRiderList]);

    useEffect(() => {
        setSortBy(props.sortBy);
        console.log('data sortBy changed', props.sortBy)
    }, [props.sortBy]);

    let lastIdentifier: string | null = null;
    let lastBorderBold = false;
    return (
        <div className={`content-table signing-content-table ${props.className ? props.className : ''}`}>
            <div className='content-header-signs'>

                <div className='client-name'>
                    שם
                    <div className={`icon sort ${props.sortBy && props.sortBy.property == 'name' ? props.sortBy.SortDirection == 'ASC' ? 'asc' : 'desc' : 'hide'
                        }`}></div>
                </div>
                <div className={`client-id ${!dynamicColsList || !dynamicColsList.includes("ת.ז.") ? 'hide' : ''}`}>
                    תז/חפ
                    <div className={`icon sort ${props.sortBy && props.sortBy.property == 'Customer.FirstName' ? props.sortBy.SortDirection == 'ASC' ? 'asc' : 'desc' : 'hide'
                        }`}></div>
                </div>
                <div className={`production ${!dynamicColsList || !dynamicColsList.includes("סוג הפקה") ? 'hide' : ''}`}>
                    סוג הפקה
                    <div className={`icon sort ${props.sortBy && props.sortBy.property == 'Customer.Identifier' ? props.sortBy.SortDirection == 'ASC' ? 'asc' : 'desc' : 'hide'
                        }`}></div>
                </div>
                <div className='insurance-company pointer'>
                    חברת ביטוח
                    <div className={`icon sort ${props.sortBy && props.sortBy.property == 'createdDate' ? props.sortBy.SortDirection == 'ASC' ? 'asc' : 'desc' : 'hide'
                        }`}></div>
                </div>
                <div className='policy-type pointer'>
                    סוג פוליסה
                    <div className={`icon sort ${props.sortBy && props.sortBy.property == 'alertDate' ? props.sortBy.SortDirection == 'ASC' ? 'asc' : 'desc' : 'hide'
                        }`}></div>
                </div>
                <div className={`route-id`} 
                // onClick={() => onSortChange('Policy.EndDate')}
                >
                    ענף
                    <div className={`icon sort ${props.sortBy && props.sortBy.property == 'endDate' ? props.sortBy.SortDirection == 'ASC' ? 'asc' : 'desc' : 'hide'
                        }`}></div>
                </div>
                <div className='route-name'>
                    מסלול
                    <div className={`icon sort ${props.sortBy && props.sortBy.property == 'topic' ? props.sortBy.SortDirection == 'ASC' ? 'asc' : 'desc' : 'hide'
                        }`}></div>
                </div>
                <div className='insurance'>
                    ביטוח
                </div>
                <div className='premia'>
                    פרמיה
                </div>
                <div className='event'>
                    אירוע
                    <div className={`icon sort ${props.sortBy && props.sortBy.property == 'UserId' ? props.sortBy.SortDirection == 'ASC' ? 'asc' : 'desc' : 'hide'
                        }`}></div>
                </div>
                <div className={`license-id`}>
                    הנכס
                </div>
                <div className={`policy-number`}>
                    מס  פוליסה
                </div>
                <div className={`alertDate`}>
                    תאריך יצירה
                </div>
                <div className={`alertDate`}>
                    תחילת ביטוח
                </div>
                <div className={`prod-hours`}>
                    שעת הפקה
                </div>
                <div className={`creator`}>
                    חתמת
                </div>
                <div className={`creator client-name`}>
                    נוצר ע"י
                </div>
                <div className={`checkBox-cell`}>
                    הפקה
                </div>
                <div className={`checkBox-cell`}>
                    גביה
                </div>
                <div className={`checkBox-cell ${!dynamicColsList || !dynamicColsList.includes("מיגון") ? 'hide' : ''}`}>
                    מיגון
                </div>
                <div className={`checkBox-cell ${!dynamicColsList || !dynamicColsList.includes("ה. תביעות") ? 'hide' : ''}`}>
                    ה. תביעות
                </div>
                <div className={`checkBox-cell ${!dynamicColsList || !dynamicColsList.includes("מסמכים") ? 'hide' : ''}`}>
                    מסמכים
                </div>
                <div className={`checkBox-cell ${!dynamicColsList || !dynamicColsList.includes("שליחה") ? 'hide' : ''}`}>
                    {/* ${!additionalColumns || (additionalColumns.sending && additionalColumns.sending.hidden) ? 'hide' : ''}`}> */}
                    שליחה
                </div>  
                <div className={`icon-comment`}>
                    <div className="icon comment"></div>
                </div>
                <div className={`status`}>
                    סטטוס
                </div>
                <div className={`creator ${!dynamicColsList || !dynamicColsList.includes("סוכן") ? 'hide' : ''}`}>
                    סוכן
                </div>
                <div className={`creator ${!dynamicColsList || !dynamicColsList.includes("קבוצת לקוחות") ? 'hide' : ''}`}>
                    קבוצת לקוחות
                </div>

                <div className="actions">
                    <Popover
                        placement="bottom"
                        content={
                            // <SelectCollumnsPopOver options={additionalColumns} onCheck={(opts: any) => onMenuOptionChange(opts)} 
                            // onHide={() => handleOpenChange(false)}
                            //  />


                            <DynamicColumns ModuleName="Signings" onChange={buildDynamicColsList} onClose={()=>setShowDropDown(false)}></DynamicColumns>

                        }
                        title="Title"
                        trigger="click"
                        open={showDropDown}
                        onOpenChange={handleOpenChange}
                    >
                        <div className='icon add black pointer'></div>
                    </Popover>
                </div>
            </div>
            <div className='content-data-table content-general-table-body content-table-body content-tasks-table-body'>
                {itemsList ? (<>
                    {itemsList.map((taskItem: any, index: number) => {
                        if (index === 0) {
                            // first row: start as bold (or false if you prefer)
                            lastBorderBold = true;
                            lastIdentifier = taskItem.identifier ?? null;
                        } else {
                            const currentIdentifier: string | null = taskItem.identifier ?? null;

                            if (currentIdentifier !== lastIdentifier) {
                                // identifier changed → flip bold flag
                                lastBorderBold = !lastBorderBold;
                                lastIdentifier = currentIdentifier;
                            }
                            // if same identifier → lastBorderBold stays as is
                        }
                        return (
                            <SigningItem
                                borderBold={lastBorderBold}
                                actionBtns={props.actionBtns}
                                details={taskItem}
                                statuses={props.statuses}
                                config={{
                                    additionalColumns: dynamicColsList,
                                    showOnlyRiders: props.showOnlyRiders
                                }}
                                setRiderToPopup={props.setRiderToPopup}
                                onUpdatePaymentsClick={props.onUpdatePaymentsClick}
                                onActivateRiderClick={props.onActivateRiderClick}
                                actions={{
                                    edit: editTask,
                                    update: onUpdate,
                                    sendEmail: sendEmail,
                                    sendWhatsApp: sendWhatsApp,
                                    setStatus: setStatus,
                                    delete: deleteSigning,
                                    onShowDocument: onShowDocument,
                                    onSelectSigning: onSelectSigning,
                                    onAddTask: onAddTask,
                                    onAssignToHandler: onAssignToHandler,
                                    addSigningComment: (commentData: any) => addSigningComment(commentData, taskItem.id),
                                    showAddTreatmentPopup: (customerId: string, policyId: string, type: number) => props.onNewOrEditTreatment(customerId, policyId, type),
                                }}

                                index={index}
                                setSigningSeen={(signingId: string) => props.setSigningSeen(signingId)}
                                handleCheckBoxRiderChange={setCheckboxRiderStateData}
                                showOnlyOpens={props.showOnlyOpens}
                            />
                        )
                    })}
                </>) : (<></>)}

                {itemsRiderList ? (<>
                    {itemsRiderList.map((taskItem: any, index: number) => {
                        borderBold = !borderBold;
                        return (
                            <SigningRiderItem
                                index={index}
                                details={taskItem}
                                statuses={props.statuses}
                                config={{
                                    additionalColumns: dynamicColsList,
                                    showOnlyRiders: props.showOnlyRiders
                                }}
                                setRiderToPopup={props.setRiderToPopup}
                                onUpdatePaymentsClick={props.onUpdatePaymentsClick}
                                onActivateRiderClick={props.onActivateRiderClick}
                                actions={{
                                    edit: editTask,
                                    update: onUpdate,
                                    sendEmail: sendEmail,
                                    sendWhatsApp: sendWhatsApp,
                                    setStatus: setStatus,
                                    delete: deleteSigning,
                                    onShowDocument: onShowDocument,
                                    onSelectSigning: onSelectSigning,
                                    onAddTask: onAddTask,
                                    onAssignToHandler: onAssignToHandler,
                                    addSigningComment: (commentData: any) => addSigningComment(commentData, taskItem.id),
                                }}
                                setSigningSeen={(signingId: string) => props.setSigningSeen(signingId)}
                                handleCheckBoxRiderChange={setCheckboxRiderStateData}
                                showAddTreatmentPopup={(customerId: string, policyId: string, type: number) => props.onNewOrEditTreatment(customerId, policyId, type)}
                            />
                        )
                    })}
                </>) : (<></>)}
            </div>
        </div>

    )
}
export default SigningTable;